<div class="section-dashboard">

	<div class="page-hero"></div>

	<div class="page-body ">

		<div class="index-title">
			<img [src]="bookimg_uri" class="book"><br>
			<a routerLink="/dashboard">천지성공 가이드북</a>
		</div>

		<section class="toc-head">
		  <div class="container">
			<p class="toc-column--sections">
			  <strong></strong> 
			</p>
		  </div>
		</section>

		<section class="toc-component">
			<div class="container">
				<article class="toc-section toc-section--html" *ngFor="let chapter of chapters; let i=index;">

					<div class="toc-heading">
						<h3>제{{i+1}}장 {{chapter.subject}}</h3>
						<small><span>{{ chapter.length }}</span></small>
					</div>

					<ol class="toc-content">
						<li class="toc-month" *ngFor="let page of chapter.pages; let j=index" >
							<a routerLink="/page/{{page.uid}}">
								<em>{{ j+1 }}</em> {{ page.getSubjectStripped() }}
							</a>
						</li>
					</ol>
				</article>
			</div>
		</section>
	  
	</div>

</div>